import classes from './DeleteButton.module.css'

const DeleteButton = (props) => {
    return(
        <button
            className={classes.sRoundButton}
            type={props.type || "button"}
            onClick={props.onClick}
            >{props.children}
        </button>
    )
}

export default DeleteButton;